// PaidInteractionItem.js
'use strict';
import { connect } from 'react-redux';

import PaidInteractionItem from '../component/PaidInteractionItem.jsx';

import notifySendGift from '../action/notifySendGift.js';
import toggleModal from '../action/toggleModal.js';
import login from '../action/login.js';
import addvalue from '../action/addvalue.js';
import sendLiveStreamGift from '../action/sendLiveStreamGift.js';
import fetchGift from '../action/fetchGift.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getOperationData from '../selector/getOperationData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getMeData from '../selector/getMeData.js';
import getMeBalance from '../selector/getMeBalance.js';
import getGiftData from '../selector/getGiftData.js';

import { PUBLIC_PRODUCT_URL_PATH } from '../RemoteConfigKeys.js';
import { GiftUiType } from '../resource/giftConstants.js';

const mapStateToProps = (state, { streamId, productId }) => {
  const uiType = getGiftData(state, productId, 'uiType');
  const isAnimationGift = uiType === GiftUiType.APNG;
  const isPagGift = uiType === GiftUiType.PAG;

  const sessionId = getLiveStreamData(state, [streamId], 'sessionId');
  const type = getLiveStreamData(
    state,
    [streamId, 'session', sessionId, 'topGift', productId],
    'type'
  );
  const price = getLiveStreamData(
    state,
    [streamId, 'session', sessionId, 'topGift', productId],
    'price'
  );
  const balance = getMeBalance(state);

  return {
    isNeedSendGiftConfirm: getOperationData(
      state,
      ['liveStream'],
      'isNeedSendGiftConfirm'
    ),
    isAnimationGift,
    isPagGift,
    isAuthed: !!getMeData(state, 'id'),
    type,
    title: getLiveStreamData(
      state,
      [streamId, 'session', sessionId, 'topGift', productId],
      'title'
    ),
    publicProductUrlPath: getRemoteConfigData(state, PUBLIC_PRODUCT_URL_PATH),
    pagImage: getGiftData(state, productId, 'pagImage'),
    price,
    duration: getLiveStreamData(
      state,
      [streamId, 'session', sessionId, 'topGift', productId],
      'duration'
    ),
    hasEnoughBalance: balance >= price,
  };
};

const mapStateToDispatch = dispatch => {
  return {
    notifySendGift: payload => dispatch(notifySendGift(payload)),
    sendGift: payload => dispatch(sendLiveStreamGift(payload)),
    toggleModal: payload => dispatch(toggleModal(payload)),
    login: () => dispatch(login({ shouldChooseEntryOption: false })),
    addvalue: payload => dispatch(addvalue(payload)),
    fetchGift: payload => dispatch(fetchGift(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(PaidInteractionItem);
